import modalTemplate from './assets/templates/modal.mst'
import './assets/styles/modal.scss'
import jQuery from 'jquery'
import closeIcon from '../../assets/images/close.svg'
/**
 * Create the modal if dont exist and return jQuery object with the modal DOM
 */
function create () {
  // If the modal exists, then return modal JQuery object. Else render the modal template
  let $modal = jQuery('.wgt-action-modal-template')
  if (jQuery('.wgt-action-modal-template').length) {
    return $modal
  } else {
    $modal = jQuery(jQuery.mustache(modalTemplate, {
      modalContent: '',
      title: '',
      closeIcon: closeIcon
    }))
  }
  let modalDOM = $modal[0]
  $modal.find('.wgt-action-modal-close').on('click', function () {
    modalDOM.style.display = 'none'
  })
  window.addEventListener('click', function (event) {
    if (event.target === modalDOM) {
      modalDOM.style.display = 'none'
    }
  })
  jQuery('body').append(modalDOM)
  return $modal
}
/**
 * Replace the body and title content inside the modal
 * @param {object} params - The parameters for render inside the modal
 * @param {string} params.content - The html element for render inside the modal body, an image for example.
 * @param {string} params.title - The modal title
 */
function replaceContent (params) {
  jQuery('.wgt-action-modal-body').html(params.content)
  jQuery('.wgt-action-modal-title').html(params.title)
}
export default {
  create,
  replaceContent
}
